import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { InstructionSortField, SortingOrder } from "@/graphql/codegen/graphql"
import InstructionContainer from "@/screens/ManageProducts/components/Instructions/containers/InstructionContainer"

const SearchParamsValidator = z.object({
  isActive: fallback(z.boolean().optional().default(true), true),
  query: fallback(z.string().optional().default(""), ""),
  field: fallback(z.nativeEnum(InstructionSortField), InstructionSortField.Name),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Asc),
})

export const Route = createFileRoute("/app/admin/manage-products/_layout/instructions")({
  validateSearch: SearchParamsValidator,
  search: {
    middlewares: [retainSearchParams(["query", "field", "order", "isActive"])],
  },
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.INSTRUCTION_MAINTENANCE]}>
      <InstructionContainer />
    </PermissionContentWrapper>
  ),
})
